import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import styles from './ModalLockedModifiers.module.css';
import { Modifier } from '@/types/menus.types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IProps {
  isOpen: boolean;
  lockedModifiers: Modifier[];
  onClose: () => void;
}

const ModalLockedModifiers = (props: IProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, lockedModifiers } = props;
  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={() => onClose()}
      headerContent={t('menuDetails.modalLockedModifiers.lockedModifiers')}
      showTitleDivider
      bodyClass={styles.modalBodyOver}
      bodyContent={
        <Box p={3}>
          <div className={styles.body}>
            <p className={styles.message}>{t('menuDetails.modalLockedModifiers.theseModifiersWereNotSelected')}</p>

            <ul style={{ listStyle: 'unset', fontSize: '1.5em', paddingLeft: '20px' }}>
              {lockedModifiers.map((prod) => (
                <Typography
                  key={`${prod.modifierId || prod.modifierName}`}
                  className={styles.message}
                  component="p"
                  fontSize="1.6rem"
                  pl={0}
                >
                  {`${prod.modifierName}, ${prod.modifierDescription}`}
                </Typography>
              ))}
            </ul>
          </div>
        </Box>
      }
      footerContent={
        <div className={styles.buttons}>
          <Button
            style={{ width: '12.5em', display: 'flex', justifyContent: 'center' }}
            variant={ButtonVariants.Primary}
            onClick={() => onClose()}
            type="button"
            data-testid="close-modal"
          >
            Close
          </Button>
        </div>
      }
    />
  );
};
export default ModalLockedModifiers;
